/**
 * @generated SignedSource<<a9f67e6bdf8af7d1d57f5a20e0a3b2ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectGroupIndicator_projectGroup$data = {
  readonly name: string | null;
  readonly companyProjectGroupId: number | null;
  readonly color: string | null;
  readonly " $fragmentType": "ProjectGroupIndicator_projectGroup";
};
export type ProjectGroupIndicator_projectGroup$key = {
  readonly " $data"?: ProjectGroupIndicator_projectGroup$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectGroupIndicator_projectGroup">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectGroupIndicator_projectGroup",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyProjectGroupId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "type": "ProjectGroupType",
  "abstractKey": null
};

(node as any).hash = "ce28c265c139a23c9a4727cea25732ab";

export default node;
